module.exports = __webpack_public_path__ + "static/media/white-t-shirt.71997f8c.jpg";